<app-breadcrumbs [breadcrumbs]="breadcrumbs" [showHome]="false" class="d-block mb-4"></app-breadcrumbs>

<h2>{{ prefix + '-titel' | fromDictionary }}</h2>

<ng-container *ngIf="customer$() as customer">
  <ng-container *ngIf="addresses$() as addresses">
    <app-profile-card [customer]="customer" [hasVatNumber]="!!customerVatNumber$()" [hasAdress]="!!addresses.length"></app-profile-card>
  </ng-container>

  <section class="mt-5" *ngIf="addresses$() as addresses">
    <div class="d-flex justify-content-between mb-3">
      <h3 class="mb-2">{{ 'adressen-titel' | fromDictionary }}</h3>

      <a
        [routerLink]="['/', 'account', 'add-address']"
        [queryParams]="{ returnUrl: '/account' }"
        class="button button--secondary float-end"
        *ngIf="addresses.length"
      >
        <app-icon anchor="icon-plus"></app-icon>
        <span>{{ 'adressen-toevoegen-knoptekst' | fromDictionary }}</span>
      </a>
    </div>
    <ul>
      <li class="mb-2" *ngFor="let address of addresses">
        <app-address-card
          [isDefaultAddress]="compareAddressIds(customer.defaultAddress?.id, address.id)"
          [address]="address"
          [id]="cleanAddressId(address.id)"
          (action)="handleAddressCardAction($event)"
          [loadingState]="addressUpdateState$()"
        ></app-address-card>
      </li>
      <li class="mb-2" *ngIf="!addresses.length">
        <app-alert class="d-block mb-3 text-center" [status]="'type--info'">
          <div class="px-3 py-4">
            <h2 class="h4 text-secondary mt-0">{{ 'adressen-overzicht-leeg-titel' | fromDictionary }}</h2>
            <p class="mb-3 text-dark">{{ 'adressen-overzicht-leeg-tekst' | fromDictionary }}</p>
            <a
              [routerLink]="['/', 'account', 'add-address']"
              [queryParams]="{ returnUrl: '/account' }"
              class="button button--light button--sm"
            >
              <span>{{ 'adressen-toevoegen-knoptekst' | fromDictionary }}</span>
            </a>
          </div>
        </app-alert>
      </li>
    </ul>

    <div class="text-center mt-3" *ngIf="addressPage$()?.hasNextPage" (fstrInViewport)="loadMoreAddresses()" [once]="false">
      <button class="button button-outline button--secondary" (click)="loadMoreAddresses()">
        {{ 'adressen-toon-meer' | fromDictionary }}
      </button>
    </div>
  </section>
</ng-container>
